// Where on the store front a product is added to the cart from — the product
// page's buy button, a card in a list, the cart's upsell, the "+" of the cart
// rail… Every add says its placement (store/cart.js track("ADD_TO_CART")), and
// the admin's dashboards count them (aldoo-com-api analytics/lib/cart-placements:
// Admin → Store → Dashboards, "Add-to-cart placements").
//
// A list says it for all its cards at once: <CartPlacement value="see_also">
// around it, read by ProductBox / ProductRow / ProductPurchaseUI (usePlacement);
// a component that knows its own passes it straight to addToCart.
import { createContext, createElement, useContext } from "react"

export const PLACEMENTS = {
  PRODUCT_PAGE: "product_page",
  PRODUCT_PAGE_STICKY: "product_page_sticky",
  PRODUCT_PAGE_MOBILE: "product_page_mobile",
  PRODUCT_GALLERY: "product_gallery",
  // the buy bar of the book player ("Look inside")
  LOOK_INSIDE: "look_inside",
  MEDIA_PAGE: "media_page",
  HOME: "home",
  CATEGORY: "category",
  SEARCH: "search",
  SELLER_PAGE: "seller_page",
  CONTENT_TYPE: "content_type",
  AUTHOR_PAGE: "author_page",
  CREATORS: "creators",
  LIBRARY: "library",
  RECENTLY_VIEWED: "recently_viewed",
  SEE_ALSO: "see_also",
  MORE_BY_AUTHOR: "more_by_author",
  MORE_FROM_SERIES: "more_from_series",
  // the series page's banner: the whole series at once
  SERIES_BANNER: "series_banner",
  RELATED: "related",
  UNAVAILABLE: "unavailable",
  CART_UPSELL: "cart_upsell",
  // the delivery step's row of products that bring a seller to free delivery
  UPSELL_DELIVERY: "upsell_delivery",
  CART_RAIL: "cart_rail",
  CART_LINE: "cart_line",
  BUY_LINK: "buy_link",
  // an earlier order back in the cart (account → Orders, "Order again")
  REORDER: "reorder",
}

const PlacementContext = createContext(null)

/** The placement of every add made inside it. */
export const CartPlacement = ({ value, children }) => createElement(PlacementContext.Provider, { value }, children)

/** The placement an add here is made from: the component's own, else the list's, else "other". */
export function usePlacement(own) {
  const inherited = useContext(PlacementContext)
  return own || inherited || "other"
}
